import { Component, OnInit } from '@angular/core';
import { HelperProvider } from '../providers/helper.provider';
import { RestService } from '../providers/rest.service';
import { Router } from '@angular/router';
import { Page } from '../model/page';
import { Cari } from '../model/cari';
import { CariListePage } from '../model/cari-liste-page';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cariler',
  templateUrl: './cariler.component.html',
  styleUrls: ['./cariler.component.css']
})
export class CarilerComponent implements OnInit {
  showSearchResultCount = 10;
  showSearchResultCountModel: number[] = [10, 20, 50, 100];
  cariAraLoading = false;
  cariAraText = '';
  source: CariListePage = null;
  showSearchCurrentPage = 1;
  showSearchResultText = '';
  iceriAktarSource: Cari[] = null;

  constructor(private helperProvider: HelperProvider,
    private restService: RestService,
    private router: Router, private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.Cariler);
    this.getCariler();
  }

  getCariler() {
    this.restService.cariler(this.showSearchCurrentPage, this.showSearchResultCount).subscribe(res => {
      this.source = res;
    });
  }

  incele(t: Cari) {
    this.router.navigate(['cari'], { queryParams: { id: t.id, action: 'yetkili' } });
  }

  showPreviousPageSearchResults() {
    this.showSearchCurrentPage--;
    this.cariAra();
  }

  showNextPageSearchResults() {
    this.showSearchCurrentPage++;
    this.cariAra();
  }

  cariAraInputChange() {
    this.cariAra();
  }

  new() {
    this.router.navigate(['cari'], { queryParams: { id: '0', action: 'yetkili' } });
  }

  private cariAra() {

    if (this.showSearchResultCount < 1) {
      this.showSearchResultCount = 10;
    }
    if (this.showSearchResultCount > 100) {
      this.showSearchResultCount = 100;
    }
    if (this.cariAraText.length > 3) {
      this.cariAraLoading = true;
      setTimeout(() => {
        this.cariAraLoading = false;
      }, 10000);
      this.source = null;

      this.restService.cariAra(this.cariAraText, this.showSearchCurrentPage, this.showSearchResultCount).subscribe(res => {
        if (res) {
          this.source = res;
          this.showSearchResultText = this.cariAraText;
        }
        this.cariAraLoading = false;
      });
    } else {
      this.getCariler();
    }
  }

  sil(c: Cari) {
    if (confirm(`${c.cariKodu} cari kodulu kullanıcıyı silmek istediğinize emin misiniz?`)) {
      this.restService.cariSil(c.id).subscribe(res => {
        this.getCariler();
      });
    }
  }

  netsisCariAktar(preview: boolean) {
    this.iceriAktarSource = null;
    this.restService.netsisCariAktar(preview).subscribe(res => {
      if (res) {
        if (preview) {
          this.iceriAktarSource = res;
          if (this.iceriAktarSource.length === 0) {
            alert('aktarılacak sonuç bulunamadı!');
          }
        } else {
          this.getCariler();
        }
      }
    });
  }

  netsiseAktar(c: Cari) {
    if ((c.vergiNo === "") && (c.tcNo === "")) {
      this.toastrService.warning("Vergi no ya da Tc No doldurulmalıdır.", "Uyarı");
      return;
    }

    if (c.vergiNo !== "") {
      if (c.vergiNo.length !== 10) {
        this.toastrService.warning("Vergi no 10 haneli olmalı.", "Uyarı");
        return;
      }
    }

    if (c.tcNo !== "") {
      if (c.tcNo.length !== 11) {
        this.toastrService.warning("Tc Kimlik no 11 haneli olmalı.", "Uyarı");
        return;
      }
    }
    this.restService.netsisCariKaydet(c).subscribe(res => {
      this.cariAra();
    });
  }
}
